import React from 'react';
import { connect } from "react-redux";
import { Container, Row, Col, Table, Button } from 'react-bootstrap'
import PageBanner from '../common/page/PageBanner'
import Alert from '../common/modal/Alert';
import Loading from '../common/modal/Loading';
import Confirmation from '../common/modal/Confirmation';
import EmailAddressSelectionList from '../common/selection/EmailAddressSelectionList';
import PhoneNumberSelectionList from '../common/selection/PhoneNumberSelectionList';
import configData from "../../config/config.json";
import axios from "axios";

import { setSelectedControlPanelType, HealthCheckListControlPanelKey, updateHealthCheckListFilters  } from "../../redux/actions/controlPanelActions";
import { LOADING_STATUES, ALERT_TYPES } from "../constants/constants";

const componentName = HealthCheckListControlPanelKey;

const mapStateToProps = state => {

	return {
		sideNavigationOpen: state.sideNavigationReducer,
		healthCheckListFilters: state.healthCheckListFiltersReducer,
		role: state.currentUserReducer.role 
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
		updateHealthCheckListFilters: (filters) => dispatch(updateHealthCheckListFilters(filters)),
		setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
	}
}

class HealthCheckList extends React.Component {

	state = {
		filteredList: [],
		selectedId: 0,
		selectedHealthCheckName: '',
		statusType: this.props.healthCheckListFilters.statusType ? this.props.healthCheckListFilters.statusType : false,
		filterText: this.props.healthCheckListFilters.filterText ? this.props.healthCheckListFilters.filterText : '',
		emailAddressId: this.props.healthCheckListFilters.emailAddressId ? this.props.healthCheckListFilters.emailAddressId : '',
		emailAddressName: this.props.healthCheckListFilters.emailAddressName ? this.props.healthCheckListFilters.emailAddressName : '',
		phoneNumberId: this.props.healthCheckListFilters.phoneNumberId ? this.props.healthCheckListFilters.phoneNumberId : '',
		phoneNumberName: this.props.healthCheckListFilters.phoneNumberName ? this.props.healthCheckListFilters.phoneNumberName : '',
		userId: this.props.healthCheckListFilters.userId ? this.props.healthCheckListFilters.userId : '',
		userName: this.props.healthCheckListFilters.userName ? this.props.healthCheckListFilters.userName : '',
		status: '',
		showDeleteConfirmationDialog: false,
		showAlert: false,
		alertMessage: "",
		alertType: ALERT_TYPES.OK,
		showEmailAddressList: false,
		showPhoneNumberList: false,
		showUserList: false,
		filteringKey: 0 /*Is incremeted to re-render/mount the Paginator component */
	}

	showLoading = () => {
		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleCloseEmailAddressLookup = (selectedId, selectedName) => {
		this.setState({
		  showEmailAddressList: false,
		  emailAddressId: selectedId,
		  emailAddressName: selectedName,
		  filteringKey: this.state.filteringKey + 1
		},  function() { this.handleFilter() } );
	}
	
	handleEmailAddressFinderFilterClick = () => {
		this.setState( {
			showEmailAddressList : true,
			filteringKey: this.state.filteringKey + 1
		  });
	}

	handleEmailAddressFinderFilterReset = () => {
		this.setState({ emailAddressId: 0, filteringKey: this.state.filteringKey + 1 },  function() { this.handleFilter() } )
	}

	handleClosePhoneNumberLookup = (selectedId, selectedName) => {
		this.setState({
		  showPhoneNumberList: false,
		  phoneNumberId: selectedId,
		  phoneNumberName: selectedName, filteringKey: this.state.filteringKey + 1
		},  function() { this.handleFilter() } );
	}
	
	handlePhoneNumberFinderFilterClick = () => {
		this.setState( {
			showPhoneNumberList : true, filteringKey: this.state.filteringKey + 1
		  });
	}

	handlePhoneNumberFinderFilterReset = () => {
		this.setState({ phoneNumberId: 0, filteringKey: this.state.filteringKey + 1 },  function() { this.handleFilter() } )
	}

	handleTextFilter = (filterText) => {
		this.setState({ filterText: filterText, filteringKey: this.state.filteringKey + 1 },  function() { this.handleFilter() } )
	}	

	handleTextFilterReset = () => {
		this.setState({ filterText: '', filteringKey: this.state.filteringKey + 1 }, function () { this.handleFilter() })
	}

	handleSelectFilter = (filterSelected) => {
		this.setState({ statusType: filterSelected, filteringKey: this.state.filteringKey + 1 }, function () { this.handleFilter() })
	}

	handleFilter = () => {
		if (this.showLoading() !== true) {
			return;
		}

		let filters = {filterText: this.state.filterText, statusType: this.state.statusType, userId: this.state.userId, emailAddressId: this.state.emailAddressId, phoneNumberId: this.state.phoneNumberId };
		axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/healthChecks", filters, { withCredentials: true })
		.then((response) => {
			this.setState({filteredList: response.data.content.healthChecks, status: '' })
			this.props.updateHealthCheckListFilters(filters);
		}, (error) => {
			this.setState({ status: '' }, this.showWarning(error.response.data.message));
		});
	}

	handleRowEdit = (event) => {
		event.preventDefault();
		this.props.history.push('/controlPanel/healthChecks/' + event.target.closest("tr").id);
	}

	handleRowView = (event) => {
		event.preventDefault();
		this.props.history.push('/controlPanel/alertsView/' + event.target.closest("tr").id);
	}

	// Delete methods
	handleDeleteHealthCheck = () => {
		if (this.showLoading() === true) {
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/healthCheckDelete", { alertId: this.state.selectedId, filterText: this.state.filterText, statusType: this.state.statusType  }, { withCredentials: true })
				.then((response) => {
					this.setState({ status: '', filteredList: response.data.content.healthChecks },  this.showAlert(response.data.message));
				}, (error) => {
					this.setState({ status: '' }, this.showWarning(error.response.data.message));
				});

			this.props.history.push('/controlPanel/healthChecks');
		}
	}

	showDeleteConfirmation = (event) => {
		let selectedId =  event.target.closest("tr").id;
		let selectedHealthCheckName = event.target.closest("tr").getAttribute("name");
	
		this.setState({
			selectedId,
			selectedHealthCheckName,
			showDeleteConfirmationDialog: true
		})
	}

	hideDeleteConfirmation = () => {
		this.setState({
			showDeleteConfirmationDialog: false
		})
	}
	// Delete methods - End


	// Activate/deactivate methods
	
	handleChangeHealthCheckStatus = (event) => {
		event.preventDefault();
		let selectedId = event.target.closest("tr").id;
		this.setState({ selectedId}, () => this.submitHealthCheckStatus());
	}
	
	submitHealthCheckStatus = () => {
		if (this.showLoading() === true) {
			axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/healthCheckChangeStatusList", { alertId: this.state.selectedId, filterText: this.state.filterText, statusType: this.state.statusType }, { withCredentials: true })
				.then((response) => {
					this.setState({ status: '', filteredList: response.data.content.healthChecks }, this.showAlert(response.data.message));
				}, (error) => {
					this.setState({ status: '' }, this.showWarning(error.response.data.message));
				});
		}
	}

	//  Activate/deactivate methods - End

	// New Alert

	openNewHealthCheckEntry = (event) => {
		event.preventDefault();
		this.props.history.push('/controlPanel/healthChecks/0');
	}

	showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }

	showWarning = (alertMessage) => {
		this.setState({
		  alertType: ALERT_TYPES.WARNING,
		  showAlert: true,
		  alertMessage
		})
	}
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: "",
			alertType: ALERT_TYPES.OK
		}, this.props.history.push('/controlPanel/healthChecks'))
	}

	componentDidMount() {
		this.props.setSelectedControlPanelType();
		this.handleFilter();
	}

	render() {

		let formTemplateMarginLeft = 60
		if (this.props.sideNavigationOpen) {
		  formTemplateMarginLeft = 270
		}
		
		let buttons = [{ label: 'New', onClickAction: this.openNewHealthCheckEntry }]

		const selectFilterProps = {
			selectFilter: this.handleSelectFilter,
			options: [{code: "ALL", description: "All Health Checks"}, {code: "A", description: "Active Only"},{code: "I", description: "Inactive Only"} ],
			selected: this.state.statusType
		}

		const textFilterProps = {
			textFilter: this.handleTextFilter,
			textFilterReset: this.handleTextFilterReset,
			filterText: this.state.filterText
		}

		const emailAddressFinderFilterProps = {
			finderFilterClick: this.handleEmailAddressFinderFilterClick,
			finderFilterReset: this.handleEmailAddressFinderFilterReset,
			name: this.state.emailAddressName,
			id: this.state.emailAddressId
		}

		const phoneNumberFinderFilterProps = {
			finderFilterClick: this.handlePhoneNumberFinderFilterClick,
			finderFilterReset: this.handlePhoneNumberFinderFilterReset,
			name: this.state.phoneNumberName,
			id: this.state.phoneNumberId
		}
		
		return (
			<div style={{ marginTop: 4, marginLeft: formTemplateMarginLeft, marginRight: 20, paddingBottom: 4, borderTop: '1px solid lightGray', boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.55), 0 6px 20px 0 rgba(0, 0, 0, 0.54)"  }}>
				{ 	
					(this.props.role === 'FOREVER' || this.props.role === 'TRIMIN' || this.props.role === 'COUNTY') &&
					<PageBanner pageHeading='Health Checks' textFilterProps={textFilterProps} selectFilterProps={selectFilterProps}  finderFilterProps={emailAddressFinderFilterProps} finderFilterProps2={phoneNumberFinderFilterProps} buttons={buttons} />
				}
				{ 	
					(this.props.role !== 'FOREVER' && this.props.role !== 'TRIMIN' && this.props.role !== 'COUNTY') &&
					<PageBanner pageHeading='Health Checks' textFilterProps={textFilterProps} selectFilterProps={selectFilterProps} buttons={buttons} />
				}
				<Container fluid="true">
					<Row>
						<Col style={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 0, marginTop: 20, marginLeft: 20,  marginRight: 20, border: '3px solid darkGray', borderRadius: '5px' }}>
							<Table striped hover size="sm" >
								<thead>
									<tr>
										<th style={{width:'25%'}} scope="col">Name</th>
										<th style={{width:'25%'}} scope="col">Alert Criteria</th>
										<th style={{width:'10%'}} scope="col">Schedule</th>
										<th style={{width:'15%'}} scope="col">Last Complete</th>
										<th style={{width:'25%'}} scope="col"></th>
									</tr>
								</thead>

								<tbody>
									{
										this.state.filteredList.map((healthCheckResult) => {
											let inactiveBadge = '';
											if ( healthCheckResult.statusType === 'I') {
												inactiveBadge = "inactive";
											} 

											let attentionBadge = '';
											if ( healthCheckResult.needsAttention === true) {
												attentionBadge = "Attention";
											} 											

											return (
												<tr style={{ cursor: "pointer" }} id={healthCheckResult.id} name={healthCheckResult.name}  onClick={this.handleRowClick}>
													<td>{healthCheckResult.name}<span className='badge badge-light'>{inactiveBadge}</span>&nbsp;<span className='badge badge-danger'>{attentionBadge}</span></td>
													<td>{healthCheckResult.criteria}</td>
													<td>{healthCheckResult.frequency}</td>
													<td>{healthCheckResult.lastRunComplete}</td>
													<td style={{ float: 'right' }}>
														{
															healthCheckResult.username &&
															<><Button variant="primary" size='sm' onClick={this.handleRowEdit}>Edit</Button>&nbsp;</>
														}
														{
															!healthCheckResult.username &&
															<><Button variant="primary" size='sm' onClick={this.handleRowView}>View</Button>&nbsp;</>
														}
														{
															healthCheckResult.statusType === 'A' &&
															<><Button variant="danger" size='sm' onClick={this.handleChangeHealthCheckStatus}>Deactivate</Button>&nbsp;</>
														}	
														{
															healthCheckResult.statusType !== 'A' &&
															<><Button variant="secondary" size='sm' onClick={this.handleChangeHealthCheckStatus}>&nbsp;&nbsp;Activate&nbsp;&nbsp;</Button>&nbsp;</>
														}
														<Button variant="danger" size='sm' onClick={this.showDeleteConfirmation} >Delete</Button>
													</td>
												</tr>
											)
										})
									}
								</tbody>
							</Table>
						</Col>
					</Row>
					<Row>&nbsp;</Row>
					<Row>
					<Col style={{marginLeft: 4}}>Displaying Results: {this.state.filteredList.length}</Col>
					</Row>
					<Row>&nbsp;</Row>
				</Container>
				
				<Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
				<Confirmation show={this.state.showDeleteConfirmationDialog} cancelConfirmation={this.hideDeleteConfirmation} proceedConfirmation={this.handleDeleteHealthCheck} question={'Delete HealthCheck ' + this.state.selectedHealthCheckName+ '?'} />
				<Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} type={this.state.alertType} />
				<EmailAddressSelectionList showModal={this.state.showEmailAddressList}  onHide={(selectedId, selectedName) => this.handleCloseEmailAddressLookup(selectedId, selectedName)} />
				<PhoneNumberSelectionList showModal={this.state.showPhoneNumberList}  onHide={(selectedId, selectedName) => this.handleClosePhoneNumberLookup(selectedId, selectedName)} />
			</div>

		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(HealthCheckList);